module.exports = __webpack_public_path__ + "img/lt.0235445.svg";